import { LinearGradient } from "react-text-gradients";
import { useEffect } from "react";
import { FaRegCalendarDays, FaLocationDot } from "react-icons/fa6";
import { AddressInfo } from "../WeddingInfo/WeddingInfo";

interface SpotifyLocationProps {
  location: AddressInfo;
  weddingDate: string;
}
const SpotifyLocation: React.FC<SpotifyLocationProps> = ({
  location,
  weddingDate,
}) => {
  const clientId = "ppr0w7ahcd";

  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://openapi.map.naver.com/openapi/v3/maps.js?ncpClientId=${clientId}`;
    script.async = true;
    script.onload = () => {
      const map = new window.naver.maps.Map("map", {
        center: new window.naver.maps.LatLng(location.lat, location.lon),
        zoom: 16, // 기본 zoom 값
      });

      // 기본 마커 추가 (커스텀 이미지 제거)
      new window.naver.maps.Marker({
        position: new window.naver.maps.LatLng(location.lat, location.lon),
        map,
      });
    };

    document.body.appendChild(script);
  }, []);

  // 네이버 지도에서 내 위치로 오시는 길 열기
  const handleNavigateToNaverMap = () => {
    const webUrl = location.naverAddress;
  };

  return (
    <div>
      <div className="flex items-center space-x-2 mt-12 mb-6 mx-4 ">
        <div className="text-white font-bold">오시는 길</div>
      </div>

      <div className="p-2 mx-16 bg-[#202020] rounded-lg font-bold">
        <div className="flex items-center space-x-2 mx-12 rounded-lg shadow-all-around items-center justify-center">
          <div className="text-sm text-spotify">{location.address}</div>
        </div>
      </div>

      <div className="mt-4">
        <div className="w-full max-w-md mt-4 flex justify-center flex-col items-center">
          {/* 지도 */}
          <div
            id="map"
            className="w-[300px] h-[300px] rounded-lg shadow-md"
          ></div>

          {/* 네이버 길찾기 버튼 */}
          <button
            onClick={handleNavigateToNaverMap}
            className="mt-6 text-[#202020] font-bold py-2 px-6 rounded-lg transition bg-spotify"
          >
            📍 네이버로 길 찾기
          </button>
        </div>
      </div>
    </div>
  );
};

export default SpotifyLocation;
